// getters
export const GET_NETWORK = 'app/GET_NETWORK'
export const GET_MODALS = 'app/GET_MODALS'
export const APP_IS_READY = 'app/APP_IS_READY'
export const SERVICE_WORKER_IS_READY = 'app/SERVICE_WORKER_IS_READY'
export const PRELOAD_DATASET = 'app/PRELOAD_DATASET'
export const PRELOAD_STATUS = 'app/PRELOAD_STATUS'
export const PRELOADING = 'app/PRELOADING'
export const DISPLAY_PRELOAD_STATUS = 'app/DISPLAY_PRELOAD_STATUS'
export const ACCEPT_PRELOAD = 'app/ACCEPT_PRELOAD'
export const PRELOAD_ENDED = 'app/PRELOAD_ENDED'
export const PRELOAD_SUCCESS = 'app/PRELOAD_SUCCESS'
export const PRELOAD_ERROR = 'app/PRELOAD_ERROR'
export const NEED_TO_RELOAD_APP = 'app/NEED_TO_RELOAD_APP'
// mutations
export const SET_NETWORK = 'app/SET_NETWORK'
export const ADD_MODAL = 'app/ADD_MODAL'
export const REMOVE_CURRENT_MODAL = 'app/REMOVE_CURRENT_MODAL'
export const REMOVE_MODAL = 'app/REMOVE_MODAL'
